import { GithubAuthProvider, signInWithRedirect } from "firebase/auth"

import { firebaseAuth } from "@/plugins/session/auth/firebase"

export function handleGithubSignIn() {
    let redirectPath = window.location.pathname || "/"
    if (!redirectPath.startsWith("/")) {
        redirectPath = "/" + redirectPath
    }

    const provider = new GithubAuthProvider()
    provider.addScope("profile")
    provider.addScope("email")
    signInWithRedirect(firebaseAuth, provider)
}
